<div class="sources-settings-container">
  <div class="header-section">
    <div class="d-flex align-items-center header-actions-row">
      <button mat-icon-button (click)="back()" color="accent" class="back-button m-r-8" aria-label="Back to folder"><mat-icon>arrow_back</mat-icon></button>
      <span class="back-label">Back to folder</span>
    </div>

    @if (source.modifiedDate || source.addedDate || (source.folder && source.folder.length > 0)) {
      <div class="metadata-section">
        @if (source.folder && source.folder.length > 0) { <div class="metadata-text">Folder: {{ folderName }}</div> }
        @if (source.modifiedDate) { <div class="metadata-text">Last modified {{ getDate(source.modifiedDate) }}</div> }
        @if (source.addedDate) { <div class="metadata-text">Created {{ getDate(source.addedDate) }}</div> }
      </div>
    }

  </div>

  <nav class="section-nav">
    <button class="section-item" [class.active]="activeSection === 'general'" (click)="setActiveSection('general')">
      General
    </button>
    <button
      class="section-item"
      [class.active]="activeSection === 'embeddings'"
      (click)="setActiveSection('embeddings')"
    >
      Embeddings
    </button>
    <button
      class="section-item"
      [class.active]="activeSection === 'references'"
      (click)="setActiveSection('references')"
    >
      References
    </button>
  </nav>

  <div class="section-panel" [class.section-hidden]="activeSection !== 'general'">
    <app-sources-content [selectedItem]="source" (handleCancel)="back()"></app-sources-content>
  </div>

  <div class="section-panel" [class.section-hidden]="activeSection !== 'embeddings'">
    <app-source-embeddings [sourceItem]="source"> </app-source-embeddings>
  </div>

  <div class="section-panel" [class.section-hidden]="activeSection !== 'references'">
    <app-source-references [sourceItem]="source"> </app-source-references>
  </div>
</div>
